export var RunStatus;
(function (RunStatus) {
    RunStatus["open"] = "open";
    RunStatus["closed"] = "closed";
    RunStatus["failed"] = "failed";
    RunStatus["canceled"] = "canceled";
})(RunStatus || (RunStatus = {}));
//# sourceMappingURL=runStatus.js.map